// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__JUkOe","content":"LoadingAlert_content__32wc-"};